/*
 * Post-coupon.ts
 * Description: Includes the declaration
 * of the function for creating a coupon
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing an interface
import {Coupon} from '@/ts/coupons/validate-coupons';

/**
 * Create a coupon
 *
 * @return {Object} Promise - when the request is fulfilled
 * @param {String} slug - id of a restaurant
 * @param {Coupon} data - product data
 */
export function postCoupons(data: Coupon, slug: string) {
    const jwt = localStorage.getItem('jwt');
    return new Promise ((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/coupons',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch((error) => {
            reject(error);
        });
    });
}
